import React from 'react';

/**
 * ChannelIcon component that displays appropriate icon for channel type
 * @param {Object} props - Component props
 * @param {boolean} props.isPrivate - Whether the channel is private
 * @param {string} props.className - Additional CSS classes
 * @param {number} props.size - Icon size (default: 16)
 * @returns {JSX.Element}
 */
const ChannelIcon = ({ isPrivate = false, className = "", size = 16 }) => {
  if (isPrivate) {
    // Lock icon for private channels - use #EBA747 color
    return (
      <svg 
        xmlns="http://www.w3.org/2000/svg" 
        width={size} 
        height={size} 
        viewBox="0 0 24 24" 
        fill="none" 
        stroke="currentColor" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round" 
        className={`${className}`}
        style={{ color: '#EBA747' }}
        title="Private Channel"
      >
        <rect width="18" height="11" x="3" y="11" rx="2" ry="2"/>
        <path d="m7 11V7a5 5 0 0 1 10 0v4"/>
      </svg>
    );
  }

  // Hash icon for public channels - use brand color
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke="currentColor" 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round" 
      className={`${className}`}
      style={{ color: '#31048B' }}
      title="Public Channel"
    >
      <line x1="4" x2="20" y1="9" y2="9"/>
      <line x1="4" x2="20" y1="15" y2="15"/>
      <line x1="10" x2="8" y1="3" y2="21"/>
      <line x1="16" x2="14" y1="3" y2="21"/>
    </svg>
  );
};

export default ChannelIcon; 